// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import appealAnswerEntity from './entities/appeal-answer.json';
import appealAnswerMenu from '../pages/appeal-answer/menu.json';
import appealAnswerFullForm from '../pages/appeal-answer/forms/full.json';
import appealAnswerContextForm from '../pages/appeal-answer/forms/context.json';
import appealAnswerMiniForm from '../pages/appeal-answer/forms/mini.json';
import appealAnswerLookupForm from '../pages/appeal-answer/forms/lookup.json';
import appealAnswerTableView from '../pages/appeal-answer/views/table.json';
import appealAnswerCardsView from '../pages/appeal-answer/views/cards.json';
import appealAnswerCalendarView from '../pages/appeal-answer/views/calendar.json';
import appealAnswerDashboardView from '../pages/appeal-answer/views/dashboard.json';

/** Тип запису «Відповідь на звернення» зі сторінками пакета: меню, форми та подання з pages/appeal-answer/. */
export const appealAnswerDefinition: IRecordTypeDefinition = {
  ...appealAnswerEntity,
  views: assembleViewSet({
      table: appealAnswerTableView,
      cards: appealAnswerCardsView,
      calendar: appealAnswerCalendarView,
      dashboard: appealAnswerDashboardView,
  }),
  form: appealAnswerFullForm,
  forms: { full: appealAnswerFullForm, context: appealAnswerContextForm, mini: appealAnswerMiniForm, lookup: appealAnswerLookupForm },
  menu: appealAnswerMenu,
} as IRecordTypeDefinition;
